var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXrpWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lifestyle / XRP"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.63996 1.3335H2.69993C2.07993 1.3335 1.76661 2.08683 2.20661 2.52683L6.02659 6.34683C7.11993 7.44016 8.88659 7.44016 9.97992 6.34683L13.7999 2.52683C14.24 2.08683 13.9266 1.3335 13.3066 1.3335H12.3666C11.8133 1.3335 11.28 1.5535 10.8866 1.94683L8.49994 4.3335C8.22661 4.60683 7.78662 4.60683 7.51329 4.3335L5.12661 1.94683C4.72661 1.5535 4.19329 1.3335 3.63996 1.3335Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63996 14.6468H2.69993C2.07993 14.6468 1.76661 13.8935 2.20661 13.4535L6.02659 9.6335C7.11993 8.54016 8.88659 8.54016 9.97992 9.6335L13.7999 13.4535C14.24 13.8935 13.9266 14.6468 13.3066 14.6468H12.3666C11.8133 14.6468 11.28 14.4268 10.8866 14.0335L8.49994 11.6468C8.22661 11.3735 7.78662 11.3735 7.51329 11.6468L5.12661 14.0335C4.72661 14.4268 4.19329 14.6468 3.63996 14.6468Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXrpWhiteIcon);
export default __webpack_public_path__ + "static/media/XRPWhiteIcon.8f9b6a476fba0f4e2ca4f3a5b8468403.svg";
export { ForwardRef as ReactComponent };